import type { ContextoAcesso } from '@next/compartilhados/acesso'
import SHA256 from 'crypto-js/sha256'
import Base64 from 'crypto-js/enc-base64'

import type { ContextoDeCatalogo } from './catalogo.tipos'

export const criarContextoDeCatalogo = (
  contexto: Pick<
    ContextoAcesso,
    | 'statusUsuario'
    | 'usuario'
    | 'empresa'
    | 'perfilAtivo'
    | 'permissoes'
  >,
): ContextoDeCatalogo | null => {
  if (
    contexto.statusUsuario !== 'pronto'
    || !contexto.usuario
    || !contexto.empresa
  ) return null

  return {
    empresaId: String(contexto.empresa.id),
    usuarioId: String(contexto.usuario.id),
    perfilAtivo: contexto.perfilAtivo,
    tipoUsuario: contexto.usuario.tipo,
    permissoes: contexto.permissoes
      .map(({ nome }) => nome)
      .sort((a, b) => a.localeCompare(b)),
  }
}

export const criarHashContextoCatalogo = (
  contexto: ContextoDeCatalogo,
): string => SHA256(JSON.stringify([
  contexto.empresaId,
  contexto.usuarioId,
  contexto.perfilAtivo,
  contexto.tipoUsuario,
  [...contexto.permissoes].sort((a, b) => a.localeCompare(b)),
]))
  .toString(Base64)
  .replace(/\+/g, '-')
  .replace(/\//g, '_')
  .replace(/=+$/u, '')

export const criarChaveRegistroCatalogo = (
  catalogo: string,
  contexto: ContextoDeCatalogo,
): string => JSON.stringify([
  catalogo,
  criarHashContextoCatalogo(contexto),
])

export const criarQueryKeyCatalogo = (
  catalogo: string,
  contexto: ContextoDeCatalogo,
) => ['catalogos', catalogo, criarHashContextoCatalogo(contexto)] as const
